import { render, staticRenderFns } from "./customerMgtAdminyw.vue?vue&type=template&id=ca9bb7a2&scoped=true&"
import script from "./customerMgtAdminyw.vue?vue&type=script&lang=js&"
export * from "./customerMgtAdminyw.vue?vue&type=script&lang=js&"
import style0 from "./customerMgtAdminyw.vue?vue&type=style&index=0&id=ca9bb7a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9bb7a2",
  null
  
)

export default component.exports